const path = '$home';

 
export const NOTICEPOPUP_SET = `${path}/noticepopup/set`; 
export const NOTICEPOPUP_GET = `${path}/noticepopup/get`; 

export const NOTICEPOPUP_MODAL_SET = `${path}/noticepopup/modal/set`; 
export const NOTICEPOPUP_MODAL_GET = `${path}/noticepopup/modal/get`; 

export const NOTICEPOPUP_MODAL_LIST_SET = `${path}/noticepopup/modal/list/set`; 
export const NOTICEPOPUP_MODAL_LIST_GET = `${path}/noticepopup/modal/list/get`;  
export const NOTICEPOPUP_MODAL_IDX_SET = `${path}/noticepopup/modal/idx/set`;  
